import * as React from 'react';

function Svg24Facebook( props ){
  return (
    <svg width={ 24 }
      height={ 24 }
      role='img'
      { ...props }
      alt='Facebook'
    >
      <title>Facebook</title>
      <path
        d='M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm3 8h-1.35c-.538 0-.65.221-.65.778V10h2l-.209 2H13v7h-3v-7H8v-2h2V7.692C10 5.923 10.931 5 13.029 5H15v3z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  );
}

export default Svg24Facebook;
